export default {
  COMMUNITY_URL: 'https://stage-api-community.tcglobal.com/',
  AUTH_URL: 'https://stage-auth.tcglobal.com/',
  LEGACY_PORTAL_API: 'https://portalapistaging.tcglobal.com/api/',
  STUDENT_PORTAL_URL: 'https://spstaging.tcglobal.com',
  RM_PORTAL_URL: 'https://rmstaging.tcglobal.com',
  TCG_WEBSITE_URL: 'https://tcglobal.com',
  AUTH_ADMIN_PORTAL_URL: 'https://stage-auth.tcglobal.com/admin/',
  IS_PREVIOUSLY_VIEWED_SECTION_ACTIVE: true,
  SEGMENT_WRITE_KEY: 'X7datomCtnrCTUuDRK3MqJX5tLB30Vs1',
  ...(window.config || {}),
};
